import axios from '../config/axios'

export const getParticipantActivity = (path, token, parameter)=>axios.get(`/${path}/${token}/${parameter}`)
export const saveParticipantAnswer = (data)=>axios.put('/participant/activity/save', data)
export const skipVideoCallActivity = (participantId, urlId) => axios.post(`/trans/participant/${participantId}/url/${urlId}/skip`)